export default {
  path: '/center',
  title: '个人中心',
  icon: 'flask',
  children: (pre => [
    { path: `${pre}/index`, title: '个人中心', icon: 'iconoperate_personal_center', auth_token: 'xg:center:index' },
    // { path: `${pre}/match/index`, title: '赛事中心', icon: 'iconoperate_pop_match', auth_token: 'xg:center:index' },
    { path: `${pre}/phone`, title: '更换手机号', icon: 'iconoperate_personal_phone', auth_token: 'xg:center:phone' },
    { path: `${pre}/password`, title: '修改密码', icon: 'iconoperate_personal_password', auth_token: 'xg:center:password' }
    // { path: `${pre}/order`, title: '订单管理', icon: 'home' }
  ])('/center')
}
